import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

// J — local color constants because AppBar sits outside .j-workspace,
// so CSS variables from jTheme.css are not available here.
const J = {
    muted: '#a3d1ff',
    accent: '#66b2ff',
};
const publicNavItems = ['Features', 'Guide', 'FAQ', 'Blog'];

/**
 * Horizontal nav buttons for desktop AppBar.
 * Dashboard only visible when signed in.
 * Active route highlighted with accent color.
 */
export default function AppBarNavItems() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userId } = useAuth();

    const navItems = userId ? [...publicNavItems, 'Dashboard', 'Designer', 'Bookshelf'] : publicNavItems;

    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {navItems.map((item) => {
                const isActive = location.pathname === `/${item.toLowerCase()}`;
                return (
                    <Button
                        key={item}
                        variant="text"
                        size="small"
                        onClick={() => navigate(`/${item.toLowerCase()}`)}
                        sx={{
                            color: isActive ? J.accent : J.muted,

                            // color: isActive ? 'var(--j-accent)' : J.muted,
                            fontWeight: isActive ? 700 : 400,
                            '&:hover': { color: J.accent, bgcolor: 'transparent' },
                        }}
                    >
                        {item}
                    </Button>
                );
            })}
        </Box>
    );
}
